import { Modal } from '@cb/apricot-react';
import { FC } from 'react';

import Typography from './Typography';

interface WhatIsScoreSendCodeModalProps {
  trigger?: string;
}

const WhatIsScoreSendCodeModal: FC<WhatIsScoreSendCodeModalProps> = ({ trigger = 'whatIsScoreSendCodeModal' }) => {
  return (
    // @ts-ignore
    <Modal title="What is a Score Send Code?" trigger={trigger} withHeader withFooter>
      <div className="display-flex flex-column cb-align-left" >
        <Typography variant="body1">
        The College Board Score Send Code allows organizations offering post-secondary opportunities to receive College Board assessment scores from students interested in the opportunity offered.
        </Typography>
        <Typography variant="body1">
          <br/>
          Institutions with College Board Score Send Codes can opt to receive scores from Advanced Placement, CLEP and/or SAT programs.
          </Typography>
        <Typography variant="body1">
         <br/>
          Users should submit a Score Send Code request form to apply for a Score Send code for the first time, to request scores from additional programs, or to update organization contact information,i.e., institution name or address.
        </Typography>
      </div>
    </Modal>
  );
};

export default WhatIsScoreSendCodeModal;
